import React, { useState, useEffect } from 'react';
import moment from 'moment';
import Calendar from 'react-calendar';
import Alert from '../Alert';
import { useBeneficiarioEventual } from '../../contexts/BeneficiarioEventual/context';
import './styles.css';
import 'react-calendar/dist/Calendar.css';

function CalendarDefaultValue(props) {
    const { setDateSelected } = props;
    const [dateChange, setDate] = useState(null);
    const { datasDisponiveis } = useBeneficiarioEventual();

    useEffect(() => {
        if (dateChange) {
            setDateSelected(new Date(dateChange));
        }
    }, [dateChange]);

    function onChange(value) {
        setDate(value);
    }

    return (
        <div>
            <Alert
                type={4}
                title=""
                message="Para seguir com o agendamento de consulta você precisa selecionar uma data no calendário abaixo e clicar no botão pesquisar."
            />

            <div style={{ display: 'flex' }}>
                <Calendar
                    onChange={onChange}
                    tileClassName={({ date }) => {
                        if (datasDisponiveis.length > 0) {
                            const reponseData = datasDisponiveis.map((el) => ({
                                startDate: moment(el.data).format('DD-MM-YYYY'),
                                limitrofe: el.limitrofe,
                            }));

                            // eslint-disable-next-line prefer-arrow-callback
                            const limitrofeFalse = reponseData.find(function (el) {
                                return el.startDate === moment(date).format('DD-MM-YYYY') && el.limitrofe === false;
                            });

                            if (limitrofeFalse) {
                                return 'highlight';
                            }
                            // eslint-disable-next-line prefer-arrow-callback
                            const limitrofeTrue = reponseData.find(function (el) {
                                return el.startDate === moment(date).format('DD-MM-YYYY') && el.limitrofe === true;
                            });

                            if (limitrofeTrue) {
                                return 'highlightTrue';
                            }
                        }

                        return '';
                    }}
                />
                <div
                    style={{
                        flexDirection: 'row',
                        alignContent: 'space-between',
                        marginTop: '10px',
                    }}
                >
                    <div
                        style={{
                            display: 'flex',
                            marginLeft: '14px',
                        }}
                    >
                        <div
                            style={{
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                width: '20px',
                                height: '20px',
                                backgroundColor: '#00722c',
                                color: 'white',
                                fontWeight: 'bold',
                                borderRadius: '4px',
                            }}
                        />

                        <p style={{ marginLeft: '4px' }}>Unidades na localidade selecionada.</p>
                    </div>
                    <div
                        style={{
                            display: 'flex',
                            marginLeft: '14px',
                        }}
                    >
                        <div
                            style={{
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                width: '20px',
                                height: '20px',
                                backgroundColor: '#fffb00',
                                color: 'white',
                                fontWeight: 'bold',
                                borderRadius: '4px',
                            }}
                        />

                        <p style={{ marginLeft: '4px' }}>Unidades próximas.</p>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default CalendarDefaultValue;
